import React from "react"
import type { StepConfig, SelectOption } from "./types"
import { INPUT_CLASS } from "./constants"

interface NotifyConfigProps {
  config: StepConfig
  channels: SelectOption[]
  onChange: (updates: Partial<StepConfig>) => void
}

export function NotifyConfig({
  config,
  channels,
  onChange,
}: NotifyConfigProps) {
  return (
    <>
      <div className="space-y-1">
        <label className="block text-xs font-medium text-gray-700">
          Notification Channel
        </label>
        <select
          value={config.channel_id || ""}
          onChange={(e) => onChange({ channel_id: e.target.value })}
          className={INPUT_CLASS}
        >
          <option value="">Select channel...</option>
          {channels.map((ch) => (
            <option key={ch.value} value={ch.value}>
              {ch.label}
            </option>
          ))}
        </select>
        <p className="text-xs text-gray-400">
          Configure notification channels in account settings.
        </p>
      </div>
      <div className="space-y-1">
        <label className="block text-xs font-medium text-gray-700">
          Message Template
        </label>
        <textarea
          value={config.message_template || ""}
          onChange={(e) => onChange({ message_template: e.target.value })}
          rows={2}
          className={INPUT_CLASS}
          placeholder="Action triggered on {{endpoint_name}} for {{request_id}}"
        />
        <p className="text-xs text-gray-400">
          {"Variables: {{endpoint_name}}, {{endpoint_id}}, {{request_id}}, {{event_type}}, {{provider}}"}
        </p>
      </div>
    </>
  )
}
